module.exports = __webpack_public_path__ + "img/setting_23.86808f63.svg";